var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024.00 1024.00",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    transform: "rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.302 134.343c-46.171 0-83.599 37.904-83.599 84.666 0 46.753 37.428 84.661 83.599 84.661 46.179 0 83.607-37.908 83.607-84.661 0-46.761-37.429-84.666-83.607-84.666z",
    fill: "#C6A72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.166 305.246l-2.804-1.718c-21.688-13.291-49.909-6.259-63.035 15.704L19.112 833.375c-13.122 21.964-6.178 50.541 15.511 63.836l2.803 1.717c21.692 13.29 49.909 6.262 63.035-15.701l307.21-514.147c13.122-21.965 6.182-50.542-15.505-63.834z",
    fill: "#4F8A5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.247 808.733H58.243c-25.673 0-46.481 20.812-46.481 46.484v3.319c0 25.674 20.808 46.481 46.481 46.481h907.004c25.67 0 46.481-20.808 46.481-46.481v-3.319c0.001-25.672-20.811-46.484-46.481-46.484z",
    fill: "#2F6B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.051 845.512L796.742 221.268c-7.921-22.964-32.76-34.998-55.493-26.805l-2.944 1.061c-22.77 8.204-34.696 33.548-26.633 56.531L930.879 876.79c7.431 21.168 30.965 31.502 52.562 23.154l2.791-1.081c21.557-8.341 33.116-32.2 25.819-53.351z",
    fill: "#C7771A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.545 577.868L406.071 317.869c-13.67-21.618-42.063-27.913-63.408-14.066l-2.758 1.792c-21.349 13.844-27.563 42.595-13.893 64.209l164.475 259.997c13.674 21.616 42.064 27.915 63.406 14.064l2.763-1.786c21.349-13.846 27.563-42.6 13.889-64.211z",
    fill: "#c13e72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.738 198.775l-2.854-1.544c-21.998-11.928-50.051-4.265-62.77 17.169L492.012 583.709c-13.774 23.227-6.701 52.796 15.921 65.989l2.934 1.706c22.701 13.239 52.28 4.892 65.938-18.582l217.178-373.22c12.604-21.655 4.829-48.863-17.245-60.827z",
    fill: "#cf3c17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.94e8d0ebefb07163a54983c54446df49.svg";
export { ForwardRef as ReactComponent };